(function() { module.exports = window["wc"]["wcBlocksRegistry"]; }());